import type { FetchResponse } from '@cian/http-api';
import type { TAddOfferToComparisonResponse } from '../../../../repositories/offers-comparison/v2/add-offer-to-comparison';
import type { IAddOfferToComparisonResponse } from '../../../../repositories/offers-comparison/entities/add_offer_to_comparison/AddOfferToComparisonResponse';

export const mapAddOfferToComparisonResponse = (
  response: IAddOfferToComparisonResponse,
): FetchResponse<TAddOfferToComparisonResponse> => {
  return {
    statusCode: 200,
    headers: [] as unknown as Headers,
    response,
  };
};
